/**
 * @generated SignedSource<<39c311ad398b99371602c812015ec46b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SaveDescoperSelectorInput = {
  brandId: string;
  selector: string;
};
export type InternBrandOnboardingSaveDescoperSelectorMutation$variables = {
  input: SaveDescoperSelectorInput;
};
export type InternBrandOnboardingSaveDescoperSelectorMutation$data = {
  readonly saveDescoperSelector: {
    readonly message: string;
    readonly success: boolean;
  };
};
export type InternBrandOnboardingSaveDescoperSelectorMutation = {
  response: InternBrandOnboardingSaveDescoperSelectorMutation$data;
  variables: InternBrandOnboardingSaveDescoperSelectorMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SaveDescoperSelectorResponse",
    "kind": "LinkedField",
    "name": "saveDescoperSelector",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternBrandOnboardingSaveDescoperSelectorMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternBrandOnboardingSaveDescoperSelectorMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fabaa44e153f3cca24d927ada4bb26e0",
    "id": null,
    "metadata": {},
    "name": "InternBrandOnboardingSaveDescoperSelectorMutation",
    "operationKind": "mutation",
    "text": "mutation InternBrandOnboardingSaveDescoperSelectorMutation(\n  $input: SaveDescoperSelectorInput!\n) {\n  saveDescoperSelector(input: $input) {\n    success\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "d292a9281728b3cdcfda8d338f732160";

export default node;
